import Icon from '../components/Icon.vue'

Icon.register({"cloud-download-alt":{"width":640,"height":512,"paths":[{"d":"M640 352C640 422.7 582.7 480 512 480H144C64.5 480 0 415.5 0 336 0 273.2 40.2 219.8 96.2 200.1A163.7-163.7 0 0 0 96 192C96 103.6 167.6 32 256 32 315.3 32 367 64.2 394.7 112.2 409.9 102 428.3 96 448 96 501 96 544 139 544 192 544 204.2 541.7 215.8 537.6 226.6 596 238.4 640 290.1 640 352zM393.4 288H328V176C328 167.2 320.8 160 312 160H264C255.2 160 248 167.2 248 176V288H182.6C168.4 288 161.2 305.2 171.3 315.3L276.7 420.7C282.9 426.9 293.1 426.9 299.3 420.7L404.7 315.3C414.8 305.2 407.6 288 393.4 288z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/cloud-download-alt.js
// module id = null
// module chunks = 